/* ASTERA – scroll reveals, before/after slider, review carousel */
(function () {
  function reveal() {
    var els = document.querySelectorAll('.a-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  function beforeAfter(root) {
    if (root.dataset.aReady) return; root.dataset.aReady = '1';
    var set = function (clientX) {
      var r = root.getBoundingClientRect();
      var p = Math.min(Math.max((clientX - r.left) / r.width, 0), 1);
      root.style.setProperty('--a-split', (p * 100).toFixed(2) + '%');
    };
    var down = false;
    root.addEventListener('pointerdown', function (e) { down = true; root.setPointerCapture(e.pointerId); set(e.clientX); });
    root.addEventListener('pointermove', function (e) { if (down) set(e.clientX); });
    ['pointerup', 'pointercancel'].forEach(function (t) { root.addEventListener(t, function () { down = false; }); });
    root.addEventListener('keydown', function (e) {
      var cur = parseFloat(root.style.getPropertyValue('--a-split')) || 50;
      if (e.key === 'ArrowLeft') { root.style.setProperty('--a-split', Math.max(0, cur - 4) + '%'); }
      if (e.key === 'ArrowRight') { root.style.setProperty('--a-split', Math.min(100, cur + 4) + '%'); }
    });
  }

  function carousel(root) {
    if (root.dataset.aReady) return; root.dataset.aReady = '1';
    var track = root.querySelector('.astera-rev__track');
    if (!track) return;
    root.querySelectorAll('[data-a-dir]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = track.querySelector('.astera-rev__card');
        var step = card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
        track.scrollBy({ left: btn.dataset.aDir === 'next' ? step : -step, behavior: 'smooth' });
      });
    });
  }

  function init() {
    reveal();
    document.querySelectorAll('.astera-ba__slider').forEach(beforeAfter);
    document.querySelectorAll('.astera-rev').forEach(carousel);
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
